var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuicksight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/64/Arch_Amazon-QuickSight_64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/64/Arch_Amazon-QuickSight_64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/64/Analytics",
    transform: "translate(0.121366, 0.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65,24 C65,22.897 64.103,22 63,22 C61.897,22 61,22.897 61,24 C61,25.103 61.897,26 63,26 C64.103,26 65,25.103 65,24 L65,24 Z M42,47 C42,45.897 41.103,45 40,45 C38.897,45 38,45.897 38,47 C38,48.103 38.897,49 40,49 C41.103,49 42,48.103 42,47 L42,47 Z M40,33 C41.103,33 42,32.103 42,31 C42,29.897 41.103,29 40,29 C38.897,29 38,29.897 38,31 C38,32.103 38.897,33 40,33 L40,33 Z M19,53 C19,51.897 18.103,51 17,51 C15.897,51 15,51.897 15,53 C15,54.103 15.897,55 17,55 C18.103,55 19,54.103 19,53 L19,53 Z M67,24 C67,26.206 65.206,28 63,28 C62.169,28 61.396,27.745 60.757,27.309 L43.415,44.948 C43.778,45.55 44,46.247 44,47 C44,49.206 42.206,51 40,51 C37.794,51 36,49.206 36,47 C36,45.142 37.279,43.589 39,43.142 L39,34.858 C38.393,34.7 37.845,34.403 37.385,34.002 L20.375,50.874 C20.766,51.491 21,52.217 21,53 C21,55.206 19.206,57 17,57 C14.794,57 13,55.206 13,53 C13,50.794 14.794,49 17,49 C17.696,49 18.342,49.195 18.912,49.509 L36.241,32.32 C36.095,31.904 36,31.465 36,31 C36,28.794 37.794,27 40,27 C42.206,27 44,28.794 44,31 C44,32.858 42.721,34.411 41,34.858 L41,43.142 C41.351,43.233 41.68,43.372 41.986,43.549 L59.443,25.792 C59.169,25.25 59,24.647 59,24 C59,21.794 60.794,20 63,20 C65.206,20 67,21.794 67,24 L67,24 Z M17,17 L63,17 L63,18 L65,18 L65,16 C65,15.448 64.553,15 64,15 L16,15 C15.447,15 15,15.448 15,16 L15,47 L17,47 L17,17 Z M63,30 L65,30 L65,64 C65,64.552 64.553,65 64,65 L16,65 C15.447,65 15,64.552 15,64 L15,59 L17,59 L17,63 L63,63 L63,30 Z",
    id: "Amazon-QuickSight-Icon_64_Squid",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicksight);
export default __webpack_public_path__ + "static/media/quicksight.cc6cb2a8e726e872ca8c099edcb04272.svg";
export { ForwardRef as ReactComponent };